<template>
  <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
    <b-col>
      <div class="margin-top-home">
        <b-row cols="1" cols-sm="1" cols-md="3" cols-lg="3" cols-xl="3">
          <b-col v-if="race.createdBy" class="text-center margin-top-bottom">
            Created by 
            <br>
            <router-link class="text-black" :to="{ name: 'Rider', params: { id: race.createdBy.id }}">
              <b>{{ race.createdBy.stravaDetails.firstname }} {{ race.createdBy.stravaDetails.lastname }}</b>
              &nbsp;<b-badge pill variant="primary">{{ race.createdBy.level }}</b-badge>
              <br>
              <img v-if="race.createdBy.stravaDetails.profile" :src="race.createdBy.stravaDetails.profile" width="50px">
              <img v-else src="https://icon-library.com/images/unknown-person-icon/unknown-person-icon-19.jpg" width="50px">
            </router-link>
          </b-col>
          <b-col class="margin-top-bottom text-center">
            <div class="inline">
              <img src="../../public/openseries.png" width="120px">
              <span class="bigger-font-x2 margin-left">{{ race.name }}</span>
              <span v-if="race.isEBike">&nbsp;<img src="../../public/thunder.png" width="20px"> (E-Bike)</span>
            </div>
            <br><br>
            <div v-if="!race.validated" class="text-center failure">
              <h5>Status: Waiting for approval</h5>
              <span>The race is not public yet. It must be approved by an admin. The creator will be notified by email when it's approved</span>
            </div>
            <div v-else class="text-center">
              <a @click.prevent="viewRules()" class="text-blue">How to join the race?</a>
            </div>
          </b-col>
          <b-col v-if="race.recommendedRoute" class="text-center margin-top-bottom">
            Save the recommended route on Strava:
            <br>
            <a :href="`https://www.strava.com/routes/${race.stravaRecommendedRouteId}`" target="_blank" class="strava">View on Strava</a>
            <br>
            <br>
            <div>
              Share race:
              <a><fa-icon :icon="['far', 'copy']" @click="copyToClipboard(raceLink)"/></a>
            </div>
          </b-col>
        </b-row>
        <br>
        <span class="failure">{{ failureMessage }}</span>
        <b-row v-if="race.itineary" cols="1" cols-sm="2" cols-md="4" cols-lg="4" cols-xl="4" class="text-center">
          <b-col>
            <b>Riders:</b> {{ race.riders }}
          </b-col>
          <b-col>
            <b>Stages:</b> {{ race.itineary | numberOfStages }}
          </b-col>
          <b-col>
            <b>Distance:</b> {{ race.recommendedRoute.stravaDetails.distance | metersToKilometers }} km
          </b-col>
          <b-col>
            <b>Elevation:</b> {{ race.recommendedRoute.stravaDetails.elevation_gain | meters }} m
          </b-col>
        </b-row>
        <br>
        <div>
          <b-form-checkbox
            id="rotation"
            class="text-right"
            v-model="rotation"
            name="rotation"
            switch
          >
            Auto rotation
          </b-form-checkbox>
          <div id="map" class="map"></div>
          <br>
          <br>
          <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
            <b-col>
              <div class="text-center"><h4 class="inline">Ranking</h4>&nbsp;&nbsp;(Total riders: {{ raceRankingPagination.count }})</div>
              <b-table :fields="fields2" :items="ranking" responsive="sm">
                <template #cell(rank)="data">
                  <b>{{ data.item.rank }}</b>
                </template>

                <template #cell(racePoints)="data">
                  {{ data.item.racePoints }}
                </template>

                <template #cell(rider)="data">
                  <router-link class="text-black" :to="{ name: 'Rider', params: { id: data.item.user.id }}">
                    <img v-if="data.item.user.stravaDetails.profile" :src="data.item.user.stravaDetails.profile" width="25px">
                    <img v-else src="https://icon-library.com/images/unknown-person-icon/unknown-person-icon-19.jpg" width="25px">
                    <b class="margin-left">{{ data.item.user.stravaDetails.firstname }} {{ data.item.user.stravaDetails.lastname }}</b>
                  </router-link>
                  &nbsp;<b-badge pill variant="primary">{{ data.item.user.level }}</b-badge>
                </template>

                <template #cell(startDate)="data">
                  {{ data.item.startDate | date }}
                </template>

                <template 
                  v-for="stage in stages"
                  v-slot:[head(stage.id)]="data"
                >
                  <span v-bind:key="stage.id">
                    {{ data.label }}
                  </span>
                </template>

                <template 
                  v-for="stage in stages"
                  v-slot:[cell(stage.id)]="data"
                >
                  <span v-bind:key="stage.id">
                    {{ data.item.details | getStageTime(stage.number) }}
                  </span>
                </template>
                
                <template #cell(penaltyTime)="data">
                  <i>{{ data.item.penaltyTime | secondsToMinutes }}</i>
                </template>

                <template #cell(finalTime)="data">
                  <b>{{ data.item.finalTime | secondsToMinutes }}</b>
                </template>

                <template #cell(totalAttempts)="data">
                  <a @click.prevent="viewAttempts(data.item.user)">{{ data.item.totalAttempts }}</a>
                </template>

                <template #cell(activity)="data">
                  <a :href="`https://www.strava.com/activities/${data.item.activity.stravaActivityId}`" target="_blank" class="strava smaller-font">
                    View on Strava
                  </a>
                </template>
              </b-table>
              <div class="center-align">
                <fa-icon class="margin-right" icon="chevron-left" @click="pagination('minus', 'getRaceRanking', 'raceRankingPagination')"/>
                Page: {{ raceRankingPagination.page }} / {{ raceRankingPagination.totalPages }}
                <fa-icon class="margin-left" icon="chevron-right" @click="pagination('plus', 'getRaceRanking', 'raceRankingPagination')"/>
              </div>
            </b-col>
          </b-row>
          <br>
          <br>
          <b-row cols="1" cols-sm="1" cols-md="2" cols-lg="2" cols-xl="2">
            <b-col>
              <h4 class="text-center">Itineary</h4>
              <b-table :fields="fields1" :items="itineary" responsive="sm">
                <template #cell(steps)="data">
                  <span v-if="data.item.type === 'stage'">
                    <b>{{ lodash.capitalize(data.item.type) }} {{ data.item.number }}</b>
                  </span>
                  <span v-else>
                    {{ lodash.capitalize(data.item.type) }}
                  </span>
                </template>

                <template #cell(nameTime)="data">
                  <span v-if="data.item.segment && data.item.segment.stravaDetails && data.item.segment.stravaDetails.name">
                    <b>{{ data.item.segment.stravaDetails.name }}</b>
                    <br>
                    <a :href="`https://www.strava.com/segments/${data.item.stravaSegmentId}`" target="_blank" class="strava smaller-font">
                      View on Strava
                    </a>
                  </span>
                  <span v-if="data.item.transferTime">{{ data.item.transferTime }}min</span>
                </template>
                
                <template #cell(distance)="data">
                  <span v-if="data.item.segment && data.item.segment.stravaDetails && data.item.segment.stravaDetails.distance">
                    {{ data.item.segment.stravaDetails.distance | metersToKilometers }} km
                  </span>
                </template>

                <template #cell(average_grade)="data">
                  <span v-if="data.item.segment && data.item.segment.stravaDetails && data.item.segment.stravaDetails.average_grade">
                    {{ data.item.segment.stravaDetails.average_grade }} %
                  </span>
                </template>

                <template #cell(elevation)="data">
                  <span v-if="data.item.segment && data.item.segment.stravaDetails && data.item.segment.stravaDetails.elevation_high && data.item.segment.stravaDetails.elevation_low">
                    -{{ data.item.segment.stravaDetails.elevation_high - data.item.segment.stravaDetails.elevation_low | meters }} m
                  </span>
                </template>
              </b-table>
            </b-col>
            <b-col>
              <h4 class="text-center">This race is part of the following trophies:</h4>
              <br>
              <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1" class="margin">
                <b-col>
                  <div class="text-center"><h5 class="inline">Current trophies</h5>&nbsp;&nbsp;(Coming {{ trophiesLimit }})</div>
                  <div v-if="comingTrophies.length > 0">
                    <div
                      v-for="trophy in comingTrophies"
                      :key="trophy.id"
                      class="margin-top-bottom"
                    >
                      <router-link class="text-black text-decoration-none" :to="{ name: 'Trophy', params: { id: trophy.id }}">
                        <b-card border-variant="transparent" bg-variant="transparent">
                          <b-card-text>
                            <div class="inline">
                              <img src="../../public/trophy.png" width="30px">
                              <span class="bigger-font-x2 margin-left">{{ trophy.name }}</span>
                              &nbsp;&nbsp;<span>Club: {{ trophy.club.name }}</span>
                            </div>
                            <br>
                            <br>
                            <b-row cols="2" cols-sm="2" cols-md="2" cols-lg="2" cols-xl="2">
                              <b-col>
                                <b>Trophy start date:</b> {{ trophy.startDate | date }}
                                <br><br>
                                <b>Trophy end date:</b> {{ trophy.endDate | date }}
                              </b-col>
                              <b-col>
                                <b>Participants:</b> {{ trophy.riders }}
                                <br><br>
                                <b>Races:</b> {{ trophy.races }}
                              </b-col>
                            </b-row>
                            <br>
                            (Race is between the {{ trophy.raceTrophy.startDate | date }} and the {{ trophy.raceTrophy.endDate | date }})
                          </b-card-text>
                        </b-card>
                      </router-link>
                    </div>
                  </div>
                  <div v-else>
                    <div class="text-center">No trophies</div>
                  </div>
                  <br>
                  <br>
                  <div class="text-center"><h5 class="inline">Past trophies</h5>&nbsp;&nbsp;(Last {{ trophiesLimit }})</div>
                  <div v-if="pastTrophies.length > 0">
                    <div
                      v-for="trophy in pastTrophies"
                      :key="trophy.id"
                      class="margin-top-bottom"
                    >
                      <router-link class="text-black text-decoration-none" :to="{ name: 'Trophy', params: { id: trophy.id }}">
                        <b-card border-variant="transparent" bg-variant="transparent">
                          <b-card-text>
                            <div class="inline">
                              <img src="../../public/trophy.png" width="30px">
                              <span class="bigger-font-x2 margin-left">{{ trophy.name }}</span>
                              &nbsp;&nbsp;<span>Club: {{ trophy.club.name }}</span>
                            </div>
                            <br>
                            <br>
                            <b-row cols="2" cols-sm="2" cols-md="2" cols-lg="2" cols-xl="2">
                              <b-col>
                                <b>Trophy start date:</b> {{ trophy.startDate | date }}
                                <br><br>
                                <b>Trophy end date:</b> {{ trophy.endDate | date }}
                              </b-col>
                              <b-col>
                                <b>Participants:</b> {{ trophy.riders }}
                                <br><br>
                                <b>Races:</b> {{ trophy.races }}
                              </b-col>
                            </b-row>
                            <br>
                            (Race was between the {{ trophy.racesTrophy[0].startDate | date }} and the {{ trophy.racesTrophy[0].endDate | date }})
                          </b-card-text>
                        </b-card>
                      </router-link>
                    </div>
                  </div>
                  <div v-else>
                    <div class="text-center">No trophies</div>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>

        <b-modal ref="rules" title="How to join a race?" hide-footer>
          <div class="d-block">
            <p>To join a race, you must first create an account on EnduroBiking.com. Click <router-link :to="{ name: 'SignUp'}">here</router-link> to create an account.</p>
            <p>Once you are logged in, search on EnduroBiking.com for the race you are willing to do.</p>
            <p>Analyze the race: check the stages and in which order you have to ride them. Check also the transfer times between stages.</p>
            <p>Open Strava, and if needed to, import the recommended route that will guide you through the race. It is optional.</p>
            <p>Launch an activity on Strava, take your bike and go reach the start of the 1st stage. Ride all the stages after another. Make sure you respect the transfer times between stages.</p>
            <p>You may not follow the recommended route for transfers. As long as you ride all stages in the right order, you are fine.</p>
            <p>When you are back, publish your activity on Strava with public confidentiality (set on "everyone can see my activity"). The activity will automatically be sent to EnduroBiking.com, and if you have performed all stages properly, you will see yourself ranked on the race leaderboard.</p>
            <p>Enjoy, and have a safe ride!</p>
          </div>
        </b-modal>

        <b-modal ref="attempts" size="xl" title="Last race attempts" hide-footer>
          <div class="d-block">
            <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
              <b-col>
                <span class="failure">{{ attemptsFailureMessage }}</span>
                <div class="text-center">
                  <h4 class="inline">
                    <router-link class="text-black" :to="{ name: 'Rider', params: { id: userAttempts.id }}">
                      <img v-if="userAttempts.stravaDetails.profile" :src="userAttempts.stravaDetails.profile" width="40px">
                      <img v-else src="https://icon-library.com/images/unknown-person-icon/unknown-person-icon-19.jpg" width="40px">
                      <b class="margin-left">{{ userAttempts.stravaDetails.firstname }} {{ userAttempts.stravaDetails.lastname }}</b>
                    </router-link>
                    &nbsp;<b-badge pill variant="primary">{{ userAttempts.level }}</b-badge>
                  </h4>
                  &nbsp;&nbsp;(Total attempts: {{ raceAttemptsPagination.count }})
                </div>
                <b-table :fields="fields3" :items="attempts" responsive="sm">
                  <template #cell(startDate)="data">
                    {{ data.item.startDate | date }}
                  </template>

                  <template 
                    v-for="stage in stages"
                    v-slot:[head(stage.id)]="data"
                  >
                    <span v-bind:key="stage.id">
                      {{ data.label }}
                    </span>
                  </template>

                  <template 
                    v-for="stage in stages"
                    v-slot:[cell(stage.id)]="data"
                  >
                    <span v-bind:key="stage.id">
                      {{ data.item.details | getStageTime(stage.number) }}
                    </span>
                  </template>
                  
                  <template #cell(penaltyTime)="data">
                    <i>{{ data.item.penaltyTime | secondsToMinutes }}</i>
                  </template>

                  <template #cell(finalTime)="data">
                    <b>{{ data.item.finalTime | secondsToMinutes }}</b>
                  </template>

                  <template #cell(activity)="data">
                    <a :href="`https://www.strava.com/activities/${data.item.activity.stravaActivityId}`" target="_blank" class="strava smaller-font">
                      View on Strava
                    </a>
                  </template>
                </b-table>
                <div class="center-align">
                  <fa-icon class="margin-right" icon="chevron-left" @click="pagination('minus', 'getRaceAttempts', 'raceAttemptsPagination')"/>
                  Page: {{ raceAttemptsPagination.page }} / {{ raceAttemptsPagination.totalPages }}
                  <fa-icon class="margin-left" icon="chevron-right" @click="pagination('plus', 'getRaceAttempts', 'raceAttemptsPagination')"/>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-modal>
      </div>
    </b-col>
  </b-row>
</template>

<script>

  import CButton from '@/components/Button'
  import mapboxgl from 'mapbox-gl/dist/mapbox-gl.js'
  import polyline from '@mapbox/polyline'
  import { PaginationModule } from '../utils.js'

  export default {
    name: 'Race',
    components: { CButton },
    props: {
      id: String
    },
    data() {
      return {
        rotation: false,
        animationFrame: null,
        failureMessage: '',
        attemptsFailureMessage: '',
        race: {},
        itineary: [],
        stages: [],
        limit: 10,
        fields1: [
          {
            key: 'steps'
          },
          {
            key: 'nameTime',
            label: 'Name/Time'
          },
          {
            key: 'distance',
          },
          {
            key: 'average_grade',
            label: 'Average grade'
          },
          {
            key: 'elevation',
          },
        ],
        ranking: [],
        fields2: [
          {
            key: 'rank'
          },
          {
            key: 'racePoints',
            label: 'Race Points'
          },
          {
            key: 'rider'
          },
          {
            key: 'startDate',
            label: 'Date'
          },
          {
            key: 'penaltyTime',
            label: 'Penalty'
          },
          {
            key: 'finalTime'
          },
          {
            key: 'totalAttempts',
            label: 'Attempts'
          },
          {
            key: 'activity'
          },
        ],
        raceRankingPagination: {
          page: 1,
          itemsPerPage: 10,
          count: null,
          totalPages: null
        },
        attempts: [],
        userAttempts: {
          stravaDetails: {}
        },
        raceAttemptsPagination: {
          page: 1,
          itemsPerPage: 10,
          count: null,
          totalPages: null,
          payload: {}
        },
        fields3: [
          {
            key: 'startDate',
            label: 'Date'
          },
          {
            key: 'penaltyTime',
            label: 'Penalty'
          },
          {
            key: 'finalTime'
          },
          {
            key: 'activity'
          },
        ],
        comingTrophies: [],
        pastTrophies: [],
        trophiesLimit: 5
      }
    },
    async created() {

    },
    async mounted() {
      await this.getRace()
      await this.getRaceRanking()
      await this.getTrophiesWithThisRace({ pastTrophies: false })
      await this.getTrophiesWithThisRace({ pastTrophies: true })
    },
    filters: {

    },
    computed: {
      user() {
        return this.$store.state.loggedUser;
      },
      raceLink() {
        return `${process.env.VUE_APP_FRONT_URL}/race/${this.id}`
      }
    },
    methods: {
      head: (id) => `head(${id})`,
      cell: (id) => `cell(${id})`,
      viewRules() {
        this.showModal('rules');
      },
      async viewAttempts(user) {
        await this.getRaceAttempts({ user });
        this.showModal('attempts');
      },
      showModal(name) {
        if (Array.isArray(this.$refs[name])) {
          this.$refs[name][0].show()
        } else {
          this.$refs[name].show()
        }
      },
      async getRace() {
        this.failureMessage = ''

        const result = await this.$apollo.query({
          client: 'public',
          query: require('@/graphql/getRace.graphql'),
          variables: {
            id: this.id
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.getRace) {
          this.race = Object.assign({}, this.race, result.data.getRace)

          this.itineary.push(...result.data.getRace.itineary)

          for (let i=0; i < this.itineary.length; i++) {
            const step = this.itineary[i]
            if (step.type === 'stage') {

              const stageId = `stage-${step.number}`
              const stageName = `Stage ${step.number}`
              
              this.stages.push({
                id: stageId,
                name: stageName,
                number: step.number,
              })

              this.fields2.splice(3 + step.number, 0, {
                key: stageId,
                label: stageName
              })

              this.fields3.splice(step.number, 0, {
                key: stageId,
                label: stageName
              })
            }
          }

          const mapData = {
            center: [this.race.location.longitude, this.race.location.latitude],
            recommendedRoute: this.race.recommendedRoute.stravaDetails.map.polyline,
            stages: {
              lines: this.race.itineary.map(step => {
                if (step.type === 'stage') {
                  return {
                    'type': 'Feature',
                    'properties': {},
                    'geometry': polyline.toGeoJSON(step.segment.stravaDetails.map.polyline)
                  }
                }
              }).filter(val => val),
              points: this.race.itineary.map(step => {
                if (step.type === 'stage') {
                  return {
                    'type': 'Feature',
                    'geometry': {
                      'type': 'Point',
                      'coordinates': [step.segment.stravaDetails.start_latlng[1], step.segment.stravaDetails.start_latlng[0]]
                    },
                    'properties': {
                      'title': `Stage ${step.number}`,
                      'id': step.stravaSegmentId,
                      'name': step.segment.stravaDetails.name,
                      'distance': this.metersToKilometers(step.segment.stravaDetails.distance),
                      'average_grade': step.segment.stravaDetails.average_grade,
                      'elevation': this.meters(step.segment.stravaDetails.elevation_high - step.segment.stravaDetails.elevation_low),
                    }
                  }
                }
              }).filter(val => val)
            }
          }

          this.loadMap(mapData)
        }
      },
      async getRaceRanking() {
        this.failureMessage = ''
        this.ranking = []

        const result = await this.$apollo.query({
          client: 'public',
          query: require('@/graphql/getRaceRanking.graphql'),
          variables: {
            raceId: this.id,
            page: this.raceRankingPagination.page,
            itemsPerPage: this.raceRankingPagination.itemsPerPage
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.getRaceRanking) {
          this.ranking.push(...result.data.getRaceRanking.raceAttempts)
          this.raceRankingPagination.count = result.data.getRaceRanking.pagination.count
          this.raceRankingPagination.totalPages = result.data.getRaceRanking.pagination.totalPages

          const userIdToCheck = this.userId ? this.userId : this.user ? this.user.id : undefined
          if (userIdToCheck) {
            for (let i=0; i < this.ranking.length; i++) {
              const rank = this.ranking[i];
              if (rank.user.id === userIdToCheck) rank._rowVariant = 'primary'
            }
          }
        }
      },
      async getRaceAttempts({ user }) {
        this.attemptsFailureMessage = ''
        this.attempts = []
        this.userAttempts = {}

        const result = await this.$apollo.query({
          client: 'public',
          query: require('@/graphql/getRaceAttempts.graphql'),
          variables: {
            raceId: this.id,
            userId: user.id,
            page: this.raceAttemptsPagination.page,
            itemsPerPage: this.raceAttemptsPagination.itemsPerPage
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.attemptsFailureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.getRaceAttempts) {
          this.attempts.push(...result.data.getRaceAttempts.raceAttempts)
          this.raceAttemptsPagination.count = result.data.getRaceAttempts.pagination.count
          this.raceAttemptsPagination.totalPages = result.data.getRaceAttempts.pagination.totalPages
          this.raceAttemptsPagination.payload = { user }
          this.userAttempts = user
        }
      },
      async getTrophiesWithThisRace({ pastTrophies = false }) {
        this.failureMessage = ''

        const result = await this.$apollo.query({
          client: 'public',
          query: require('@/graphql/getTrophiesWithRace.graphql'),
          fetchPolicy: 'no-cache',
          variables: {
            raceId: this.id,
            pastTrophies,
            limit: this.trophiesLimit
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.getTrophiesWithRace) {
          if (pastTrophies) {
            this.pastTrophies.push(...result.data.getTrophiesWithRace)
          } else {
            this.comingTrophies.push(...result.data.getTrophiesWithRace)
          }
        }
      },
      loadMap({ center, recommendedRoute, stages }) {
        mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_API_KEY;

        const map = new mapboxgl.Map({
          container: 'map',
          zoom: 14,
          center,
          pitch: 70,
          bearing: 0,
          style: 'mapbox://styles/mapbox-map-design/ckhqrf2tz0dt119ny6azh975y'
        });

        const that = this

        function rotateCamera(timestamp) {
          // clamp the rotation between 0 -360 degrees
          // Divide timestamp by 100 to slow rotation to ~10 degrees / sec
          map.rotateTo((timestamp / 100) % 360, { duration: 0 });
          // Request the next frame of the animation.
          that.animationFrame = requestAnimationFrame(rotateCamera);
        }

        map.on('load', () => {
          if (that.rotation) rotateCamera(0);

          document.getElementById('rotation').addEventListener('click', function() {
            if (!that.rotation) {
              rotateCamera(0);
            }
            if (that.rotation) {
              cancelAnimationFrame(that.animationFrame);
            }
          });
          
          map.on('mousedown', () => {
            cancelAnimationFrame(that.animationFrame);
            that.rotation = false;
          });

          map.addSource('mapbox-dem', {
            'type': 'raster-dem',
            'url': 'mapbox://mapbox.mapbox-terrain-dem-v1',
            'tileSize': 512,
            'maxzoom': 14
          });
          // add the DEM source as a terrain layer with exaggerated height
          map.setTerrain({ 'source': 'mapbox-dem', 'exaggeration': 2.0 });
          
          // add a sky layer that will show when the map is highly pitched
          map.addLayer({
            'id': 'sky',
            'type': 'sky',
            'paint': {
              'sky-type': 'atmosphere',
              'sky-atmosphere-sun': [0.0, 0.0],
              'sky-atmosphere-sun-intensity': 15
            }
          });

          map.addSource('recommendedRoute', {
            'type': 'geojson',
            'data': {
              'type': 'Feature',
              'properties': {},
              'geometry': polyline.toGeoJSON(recommendedRoute)
            }
          });

          map.addLayer({
            'id': 'recommendedRoute',
            'type': 'line',
            'source': 'recommendedRoute',
            'layout': {
              'line-join': 'round',
              'line-cap': 'round'
            },
            'paint': {
              'line-color': '#989898',
              'line-width': 5
            }
          });

          map.loadImage(
            'https://cdn-icons-png.flaticon.com/32/495/495468.png',
            (error, image) => {
              if (error) throw error;
              map.addImage('start', image);

              map.addSource('stagesLines', {
                'type': 'geojson',
                'data': {
                  'type': 'FeatureCollection',
                  'features': stages.lines
                }
              });

              map.addSource('stagesPoints', {
                'type': 'geojson',
                'data': {
                  'type': 'FeatureCollection',
                  'features': stages.points
                }
              });

              map.addLayer({
                'id': 'stagesLines',
                'type': 'line',
                'source': 'stagesLines',
                'layout': {
                  'line-join': 'round',
                  'line-cap': 'round'
                },
                'paint': {
                  'line-color': '#ffc859',
                  'line-width': 5
                }
              });

              map.addLayer({
                'id': 'stagesPoints',
                'type': 'symbol',
                'source': 'stagesPoints',
                'layout': {
                  'icon-image': 'start',
                  'text-field': ['get', 'title'],
                  'text-font': [
                    'Open Sans Semibold',
                    'Arial Unicode MS Bold'
                  ],
                  'text-offset': [0, 0],
                  'text-anchor': 'top'
                },
                'paint': {
                  'text-color': '#fff',
                }
              })

              // When a click event occurs on a feature in the places layer, open a popup at the
              // location of the feature, with description HTML from its properties.
              map.on('click', 'stagesPoints', (e) => {
                // Copy coordinates array.
                const coordinates = e.features[0].geometry.coordinates.slice();
                const id = e.features[0].properties.id;
                const name = e.features[0].properties.name;
                const title = e.features[0].properties.title;
                const distance = e.features[0].properties.distance;
                const average_grade = e.features[0].properties.average_grade;
                const elevation = e.features[0].properties.elevation;

                const html = `
                  <strong>${title}: ${name}</strong>
                  <p> 
                    <b>Distance:</b> ${distance} km
                    <br>
                    <b>Average grade:</b> ${average_grade} %
                    <br>
                    <b>Elevation:</b> -${elevation} m
                    <br>
                    <a href="https://www.strava.com/segments/${id}" target="_blank" class="strava">
                      View on Strava
                    </a>
                  </p>
                `
                
                // Ensure that if the map is zoomed out such that multiple
                // copies of the feature are visible, the popup appears
                // over the copy being pointed to.
                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                  coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                }
                
                new mapboxgl.Popup()
                  .setLngLat(coordinates)
                  .setHTML(html)
                  .addTo(map);
              });
              
              // Change the cursor to a pointer when the mouse is over the places layer.
              map.on('mouseenter', 'stagesPoints', () => {
                map.getCanvas().style.cursor = 'pointer';
              });
              
              // Change it back to a pointer when it leaves.
              map.on('mouseleave', 'stagesPoints', () => {
                map.getCanvas().style.cursor = '';
              });
            }
          )
        })
      },
      pagination(type, funcToExecute, obj) {
        const paginationModule = PaginationModule();
        const newPage = paginationModule.changePage(type, this[obj].page, this[obj].totalPages);
        if (newPage) {
          this[obj].page = newPage;
          this[funcToExecute](this[obj].payload);
        }
      },
      meters(value) {
        return value.toFixed(0)
      },
      metersToKilometers(value) {
        return (value / 1000).toFixed(2)
      },
      copyToClipboard(val) {
        this.$copyText(val).then(function () {
          alert('Copied')
        }, function () {
          alert("Couldn't copy to clipboard")
        })
      },
    }
  }
</script>

<style scoped>

</style>
